import { z } from 'zod';
import { defineForm } from '../registry.js';
import { CONFIRMERS, evidenceFields, longtext, ymd } from './common.js';

// 第4表（サービス担当者会議の要点）。旧: MeetingRecord（開催日ごと）。
// ①〜④（利用者名・生年月日・住所・計画作成者）は基本情報から読むときに転記するので本文に持たない。
// 上限は旧 API（出席者 50、文章 5000）

export const meetingAttendeeSchema = z
  .object({
    affiliation: z.string().optional().describe('所属'),
    profession: z.string().optional().describe('職種'),
    name: z.string().min(1).describe('氏名'),
    isSelf: z.boolean().optional().describe('本人出席'),
    isFamily: z.boolean().optional().describe('家族出席'),
    absent: z.boolean().optional().describe('欠席'),
    inquiryDate: z.string().meta({ kind: 'date' }).optional().describe('照会日'),
    inquiryContent: z.string().optional().describe('照会内容'),
    inquiryReply: z.string().optional().describe('回答'),
  })
  .strict();

export const careplan4Schema = z
  .object({
    heldAt: ymd.meta({ kind: 'date' }).describe('開催日'),
    place: z.string().optional().describe('開催場所'),
    time: z.string().optional().describe('開催時間'),
    count: z.string().optional().describe('開催回数'),
    attendees: z.array(meetingAttendeeSchema).max(50).default([]).describe('会議出席者'),
    examinedItems: longtext('検討した項目', 5000).optional(),
    discussion: longtext('検討内容', 5000).optional(),
    conclusion: longtext('結論', 5000).optional(),
    remainingIssues: longtext('残された課題', 5000).optional(),
    nextScheduledAt: z.string().optional().describe('次回開催時期'),
    ...evidenceFields,
  })
  .strict();
export type Careplan4Body = z.infer<typeof careplan4Schema>;

export const careplan4Form = defineForm({
  app: 'caremanager',
  docType: 'careplan4',
  name: 'サービス担当者会議の要点（第4表）',
  version: 1,
  schema: careplan4Schema,
  confirmers: CONFIRMERS,
  description: '開催日ごとに 1 件。①〜④は基本情報から転記する',
});
